const initialState = {
    cabecera: {},
};

const facturaCabeceraRedux = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CABECERA_FACTURA':
            return {
                ...state,
                cabecera: {...state.cabecera, ...action.payload } 
            }
        case 'DELETE_CABECERA_FACTURA':
            const campo = action.payload;
            const nuevoEstado = { ...state.cabecera };
            delete nuevoEstado[campo];

            return {
                ...state,
                cabecera: nuevoEstado
            }            
        default:
            return state;
    }
}

export default facturaCabeceraRedux;